import React, { Component, Fragment } from "react";
import { languageService } from "../../../Language/language.service";
import CustomForm from "../../../libraries/form";
import { updateShortSchema } from "../../../libraries/form/schemaInterpreter";
import { CRUDFunction } from "../../../reduxCURD/container";
import { curdActions } from "reduxCURD/actions";

import { userListByGroupRequest, userListRequest } from "../../../reduxRelated/actions/userActions";
import { arrayToSelectOptions } from "../../../utils/arrayToSelectOptions";
import { StyledButtonActionsTable } from "../../Common/Buttons";
import ThisTable from "../../Common/ThisTable";
import UISectionHeader from "../../Common/UISectionHeader";
import { FixedAppLookupsContext } from "../../FixedAppLookupsProvider";
import { hosUserConfigureFormSchema } from "./schemas/hosUserConfigureFormSchema";
import { hosUsersTableSchema } from "./schemas/hosUsersTableSchema";
import _ from "lodash";
import "./style.css";
import { ToastService } from "../../../utils/toastify";
import { dataFormatters } from "../../../utils/dataFormatters";
import SpinnerLoader from "../../Common/SpinnerLoader";
import { TIMEZONE_SELECT_OPTIONS } from "../../../utils/timezone";
import moment from "moment";
import { dateSort } from "../../../utils/sortingMethods";

class HosUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openHosUserConfigureFormFlag: false,
      hosUserConfigureFormUpdatedSchema: null,
      hosUserConfigureFormData: {},
      hosUserConfigureFormState: null,
      selectedUser: null,
      showloader: false,
    };

    this.closeDialog = this.closeDialog.bind(this);
    this.openHosUserConfigureForm = this.openHosUserConfigureForm.bind(this);
    this.updateHosForUser = this.updateHosForUser.bind(this);
    this.compileHosUserConfigureFormSchema = this.compileHosUserConfigureFormSchema.bind(this);
    this.setShowLoader = this.setShowLoader.bind(this);
  }

  setShowLoader(status) {
    this.setState({ showloader: status });
  }

  compileHosUserConfigureFormSchema() {
    const { getHosLocationsSelectOptions } = this.context;

    let formSchema = updateShortSchema(_.cloneDeep(hosUserConfigureFormSchema), {
      timezone: {
        selectOptions: TIMEZONE_SELECT_OPTIONS,
      },
      HQ: {
        selectOptions: getHosLocationsSelectOptions(),
      },
    });
    return formSchema;
  }

  closeDialog() {
    this.setState({
      openHosUserConfigureFormFlag: false,
      hosUserConfigureFormData: {},
      hosUserConfigureFormState: null,
      selectedUser: null,
    });
  }

  openHosUserConfigureForm(state, data) {
    const { original, row } = data;
    this.setState({
      openHosUserConfigureFormFlag: true,
      hosUserConfigureFormUpdatedSchema: this.compileHosUserConfigureFormSchema(),
      hosUserConfigureFormData: {
        name: row.name,
        email: row.email,
        HQ: row.HQ ? row.HQ : null,
        timezone: row.timezone ? row.timezone : null,
        startDate: row.startDate ? row.startDate : null,
      },
      hosUserConfigureFormState: state,
      selectedUser: { ...original },
    });
  }

  updateHosForUser(submission) {
    const { updateMyHoursOfService } = this.props;
    const { selectedUser } = this.state;
    let fields = { ...submission.fields };
    const userId = selectedUser && selectedUser._id;
    if (!selectedUser || !selectedUser.HosInfo || !selectedUser.HosInfo.startDate) {
      fields.startDate = dataFormatters.stringifyDateInYYYYMMDD(fields.startDate);
    }
    // Set HOS for the user
    updateMyHoursOfService && updateMyHoursOfService(_.pick(fields, ["timezone", "startDate", "HQ"]), `configureHos/${userId}`);
    this.closeDialog();
  }

  componentDidMount() {
    // Fetch All Users
    this.props.userListRequest();
  }

  componentDidUpdate(prevProps, prevState) {
    const { MyHoursOfServiceActionType, MyHoursOfService, getMyLatestHosInfo } = this.props;
    if (MyHoursOfServiceActionType !== prevProps.MyHoursOfServiceActionType) {
      if (MyHoursOfServiceActionType === "MYHOURSOFSERVICE_UPDATE_REQUEST") {
        this.setShowLoader(true);
      } else if (MyHoursOfServiceActionType === "MYHOURSOFSERVICE_UPDATE_SUCCESS") {
        if (MyHoursOfService && MyHoursOfService["error"]) {
          const { error } = MyHoursOfService;
          ToastService.Error("Error:", error); // An informative error message received from the server
        } else {
          // Re-fetch All Users (updated)
          this.props.userListRequest();
          // Re-fetch latest HosInfo for my user
          getMyLatestHosInfo && getMyLatestHosInfo();
        }
        this.setShowLoader(false);
      } else if (MyHoursOfServiceActionType === "MYHOURSOFSERVICE_UPDATE_FAILURE") {
        this.setShowLoader(false);
      }
    }
  }
  render() {
    //filter out FRA users
    const userList = this.props.userList
      .filter((u) => {
        return u.group_id !== "fra";
      })
      .map((u) => {
        var role = "";

        if (Array.isArray(u.userGroupObj)) {
          var group = u.userGroupObj.find((g) => {
            return g._id === u.userGroup;
          });
          if (group) {
            role = group.name;
          }
        }

        return { ...u, userRole: role };
      });
    const { getHosLocationOpt2BasedOnCode } = this.context;
    const { openHosUserConfigureFormFlag, hosUserConfigureFormUpdatedSchema, hosUserConfigureFormState, hosUserConfigureFormData } =
      this.state;
    return (
      <div>
        <SpinnerLoader spinnerLoading={this.state.showloader} />
        <UISectionHeader title={languageService("HOS User Configurations")} />
        <ThisTable
          tableColumns={[
            ...hosUsersTableSchema,
            {
              Header: languageService("HQ"),
              accessor: "HosInfo.HQ",
              id: "HQ",
              minWidth: 100,
              Cell: (d) => <Fragment>{getHosLocationOpt2BasedOnCode(d.value).description}</Fragment>,
            },
            {
              Header: languageService("Time zone"),
              accessor: "HosInfo.timezone",
              id: "timezone",
              minWidth: 100,
            },
            {
              Header: languageService("Start Date"),
              accessor: "HosInfo.startDate",
              id: "startDate",
              Cell: (d) => {
                const { value, row } = d;
                const { timezone } = row;
                return (
                  <Fragment>
                    {dataFormatters.dateFormatterWithTimezone(dataFormatters.getDateFromStringWithTimezone(value, timezone), timezone)}
                  </Fragment>
                );
              },
              minWidth: 100,
              // sortMethod: dateSort,
            },
            {
              Header: languageService("Actions"),
              id: "actions",
              Cell: (d) => {
                const index = d.row._index;
                const { hq, startDate } = d.row;

                // TODO: Check for permission
                //   /**permissionCheck("MAINTENANCE", "view") */ true &&
                return (
                  <div>
                    {/* Start Date can only be set just once */}
                    {startDate ? (
                      <StyledButtonActionsTable
                        title={languageService("Configure")}
                        onClick={() => this.openHosUserConfigureForm("configure", d)}
                      />
                    ) : (
                      <StyledButtonActionsTable
                        title={languageService("Enable")}
                        onClick={() => this.openHosUserConfigureForm("setStartDate", d)}
                      />
                    )}
                  </div>
                );
              },
              minWidth: 100,
            },
          ]}
          tableData={userList ? userList : []}
          forDashboard={false}
          pagination={true}
          height={"auto"}
          onClickSelect
        />
        {openHosUserConfigureFormFlag && (
          <CustomForm
            mode="dialog"
            currState={hosUserConfigureFormState}
            fieldsData={hosUserConfigureFormData}
            formSchema={hosUserConfigureFormUpdatedSchema}
            closeDialog={this.closeDialog}
            parentRef={{
              updateHosForUser: this.updateHosForUser,
            }}
          />
        )}
      </div>
    );
  }
}

HosUsers.contextType = FixedAppLookupsContext;

/**
 *
 * Admin can access this page for now
 * TODO: Supervisors will be able to access this page later on
 * Display a list of all Users and allow the admin to enable HOS for any user from the list (even himself or other admins)
 * Enabling the HOS means configuring the start date
 * Admin can also configure the HQ for any user using this page
 */

const updateMyHoursOfService = curdActions.updateMyHoursOfService;

let variableList = {
  userReducer: {
    userList: [],
    userListByGroup: [],
  },
  MyHoursOfServiceReducer: {
    MyHoursOfService: {},
  },
};

let reducers = ["userReducer", "MyHoursOfServiceReducer"];

let actionOptions = {
  read: false,
  create: false,
  update: false,
  delete: false,
  others: {
    userListRequest,
    userListByGroupRequest,
    updateMyHoursOfService,
  },
};

const HosUsersContainer = CRUDFunction(HosUsers, "HosUsers", actionOptions, variableList, reducers, "hoursofservice");

export default HosUsersContainer;



// WEBPACK FOOTER //
// ./src/components/HoursOfService/HosUsers/index.jsx